module.exports = __webpack_public_path__ + "img/topping_okonomiyaki.0a4eaf9a.gif";